import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
	apiKey: "AIzaSyASFE-fzPZn-pu9F79ZboDRUQrIfthdKHk",
	authDomain: "nofap-guidance.firebaseapp.com",
	projectId: "nofap-guidance",
	storageBucket: "nofap-guidance.appspot.com",
	messagingSenderId: "460604880832",
	appId: "1:460604880832:web:68eddbeb01cb47efa4fa25",
	measurementId: "G-WHQBPZCTFJ"
};

firebase.initializeApp(firebaseConfig);

export default firebase;